import S from 'common/service/sanctuary';
import { createSelector } from 'reselect';
import * as R from 'ramda';
import {
  resource,
} from 'common/store/selectors';

export const getScope = ({ widgets: { consumerData } }) => consumerData;

const chooseSafeNumber = (l, r) => (Number(r) || l);

const defaultConsumerWidgetData = [
  {
    connected: 0,
    disconnected: 0,
    unknown: 0,
  }
]

export const {
  isLoading,
  getResourceContext,
  getResourceMaybe,
} = resource.factory(getScope);

export const getError = createSelector(
  getScope,
  ({ error }) => error,
);

export const getConsumerWidgetMaybe = createSelector(
  getResourceMaybe,
  resourceMaybe => S.map(
    R.mergeDeepWith(chooseSafeNumber, defaultConsumerWidgetData),
    S.chain(S.toMaybe, resourceMaybe),
  ),
);
